import { fromEntries } from '@/helpers/javascript'

import api from '@/api'
import {PropertiesResponse, Property, Section} from '@/api/properties'
import {Module} from "vuex";

const state = () => ({
	properties: {
		all: {} as Record<string, Property>,
		Filter: { base: [] as string[], aux: [] as string[] } as Section,
		Projection: { base: [] as string[], aux: [] as string[] } as Section,
		Graph: { base: [] as string[], aux: [] as string[] } as Section
	}
})

type PropertiesState = ReturnType<typeof state>

const store: Module<PropertiesState, PropertiesState> = {
	namespaced: true,
	state,
	getters: {},
	actions: {
		async fetchProperties ({ commit }) {
			const response = await api.properties.get()
			commit('SET_PROPERTIES', response.data)
		},

		async replaceProperty ({ commit }, { name, role, newIndex }) {
			const response = await api.properties.replace({ name, property: role, value: newIndex })
			commit('SET_PROPERTIES_SECTION', { section: response.data, role })
		},

		async updateProperty ({ commit }, property) {
			const response = await api.properties.update(property)
			commit('SET_PROPERTY', response.data)
		},

		async deleteProperty ({ commit }, property) {
			await api.properties.delete(property)
			commit('DELETE_PROPERTY', property)
		}
	},
	mutations: {
		SET_PROPERTIES (state, properties: PropertiesResponse) {
			state.properties = Object.assign(properties, { all: fromEntries(properties.all.map(p => [p.name, p])) })
		},

		SET_PROPERTIES_SECTION (state, { role, section }: { role: string, section: Section }) {
			switch (role) {
				case 'Filter': {
					state.properties.Filter = section
					break
				}
				case 'Projection': {
					state.properties.Projection = section
					break
				}
				case 'Graph': {
					state.properties.Graph = section
					break
				}
			}
		},

		SET_PROPERTY (state, property) {
			state.properties.all[property.name] = property
		},

		DELETE_PROPERTY (state, property) {
			delete state.properties.all[property.name]
			state.properties.Filter['base'] = state.properties.Filter.base.filter(p => p !== property.name)
			state.properties.Filter['aux'] = state.properties.Filter.aux.filter(p => p !== property.name)
			state.properties.Projection['base'] = state.properties.Projection.base.filter(p => p !== property.name)
			state.properties.Projection['aux'] = state.properties.Projection.aux.filter(p => p !== property.name)
			state.properties.Graph['base'] = state.properties.Graph.base.filter(p => p !== property.name)
			state.properties.Graph['aux'] = state.properties.Graph.aux.filter(p => p !== property.name)
		},

		CLEAR_PROPERTIES (state) {
			state.properties['all'] = {}
			state.properties.Filter['base'] = []
			state.properties.Filter['aux'] = []
			state.properties.Projection['base'] = []
			state.properties.Projection['aux'] = []
			state.properties.Graph['base'] = []
			state.properties.Graph['aux'] = []
		}
	}
}

export default store
